export const ULTRA_TPV_GRAPHQL_FIELDS = `
          ultraAnglesClassification
          ultraPatientDiagnosis
          ultraPatientDiagnosisText
          ultraChiefComplaints
          ultraChiefComplaintsText
          ultraMainObjectives
          ultraMainObjectivesText
          ultraArchesToTreat
          needPassiveAligners
          ultraToothInfo {
            value
            missingTeeth
            primaryDentition
          }
          ultraToothMovementRestrictions {
            value
            restrictions
            primaryDentition
          }
          ultraToothUnavailableForAttachment {
            value
            noAttachmentValues
            primaryDentition
          }
          ultraSagittalRelationship {
            value
            optionsRowOne {
              value
              improveCanineRelationshipOptions {
                value
                treatmentOptions {
                  freeText
                  ipr
                  classElastic
                  canineDistalization
                  associatedElastic
                  canineMesialization
                  molarDistalization
                  molarMesialization
                }
              }
              improveMolarRelationship {
                value
                treatmentOptions {
                  freeText
                  ipr
                  classElastic
                  canineDistalization
                  associatedElastic
                  canineMesialization
                  molarDistalization
                  molarMesialization
                }
              }
              showResultingAfterAlignment {
                value
              }
            }
            optionsRowTwo {
              value
              improveCanineRelationshipOptions {
                value
                treatmentOptions {
                  freeText
                  ipr
                  classElastic
                  canineDistalization
                  associatedElastic
                  canineMesialization
                  molarDistalization
                  molarMesialization
                }
              }
              improveMolarRelationship {
                value
                treatmentOptions {
                  freeText
                  ipr
                  classElastic
                  canineDistalization
                  associatedElastic
                  canineMesialization
                  molarDistalization
                  molarMesialization
                }
              }
              showResultingAfterAlignment {
                value
              }
            }
          }
          ultraOverjet
          ultraOverbite {
            value
            correctOpenBite {
              position
              options {
                value
                text
              }
            }
            improveDeepBite {
              position
              options {
                value
                text
                anteriorBiteRampsOptions
              }
            }
          }
          ultraMidlines {
            value
            options {
              position
              value
              specification
            }
          }
          ultraMidlinesShifts
          ultraSpacing {
            value
            options {
              position
              value
            }
            type
            leaveSpacing {
              position
              value
            }
          }
          ultraCrowding {
            value
            options {
              position
              archExpansion
              proclination
              molarDistalization
              ipr {
                value
                primaryIpr {
                  anteriorTeeth
                  rightPosteriorTeeth
                  leftPosteriorTeeth
                }
              }
            }
          }
          ultraTeethToExtract {
            value
            primaryDentition
          }
          isAuxiliariesPresent
          auxiliaryButtons
          auxiliaryPrecisionCuts
          isAdditionalApplianceRequired
          tads
          sectionalBraces
          otherAppliances
`;

export const ULTRA_REFINEMENT_TPV_GRAPHQL_FIELDS = `
          ultraSubmissionReason
          ultraSubmissionReasonText
          ultraAlignerFitting
          ultraAlignerInfo {
            name
            value
          }
          ultraAttachmentAdjustments
          ultraKeepSpecifiedAttachmentValues
          ultraOtherExaminations
          ultraDentitionSpace {
            value
            preferences {
              position
              value
            }
          }
`;
